import React from 'react';
import { DateTime } from 'luxon';
import classNames from 'classnames';
import { Ticker } from '@benzinga/ticker-ui';
import { sanitizeHTML } from '@benzinga/frontend-utils';
import { ContentFeed } from '../ContentFeed';
import { StoryObject } from '@benzinga/advanced-news-manager';
import { Brief } from '../BenzingaBriefNewsElement';
import { News } from '@benzinga/basic-news-manager';
import styles from './BenzingaBriefs.module.scss';

export interface BenzingaBriefsProps {
  className?: string;
  initialBriefs?: StoryObject[] | News[];
}

export const BenzingaBriefs: React.FC<BenzingaBriefsProps> = ({ className, initialBriefs }) => {
  return (
    <div className={classNames(styles.benzingaBriefs, { [`${className}`]: !!className })}>
      <div className={styles.benzingaBriefsHeader}>
        <h3>Benzinga Briefs</h3>
      </div>
      <ContentFeed
        contentId="Briefs"
        isInfinite
        limit={10}
        loadMore
        newsItemElement={(node: Brief, i) => {
          return <BriefsNewsListItemElement data={node} key={i} />;
        }}
        nodes={initialBriefs}
        poolLatest
        query={{ displayOutput: 'headline', tags: [799703] }}
      />
    </div>
  );
};

export const BriefsNewsListItemElement: React.FC<{ data: Brief }> = ({ data }) => {
  const date = new Date(data.created);
  const relativeDate = DateTime.fromJSDate(date).toRelative();
  return (
    <div className={styles.briefListItem}>
      <a
        className={styles.briefListItemTextContent}
        data-action="Benzinga Briefs Item Title Click"
        href={data.url}
        rel="noopener noreferrer"
        target="_blank"
      >
        {data.title && (
          <h3 className={styles.briefTitle} dangerouslySetInnerHTML={{ __html: sanitizeHTML(data.title) }} />
        )}
        <span className={styles.briefDate}>{relativeDate}</span>
        <span className={styles.readMore}>READ MORE</span>
      </a>
      {Array.isArray(data.stocks) && (
        <div className={styles.tickerList}>
          {data.stocks.map(stock => (
            <Ticker key={stock.name} symbol={stock.name} />
          ))}
        </div>
      )}
    </div>
  );
};
